// extracted by mini-css-extract-plugin
export var picture = "GalleryModal-module--picture--89865";
export var image = "GalleryModal-module--image--b89f2";
export var slider = "GalleryModal-module--slider--781c6";